var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecidingscreengoout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4468_4380)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 31,
    r: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.434 30.1602H42.2396C42.4624 30.1602 42.6762 30.2487 42.8337 30.4063C42.9913 30.5639 43.0799 30.7776 43.0799 31.0004C43.0799 31.2233 42.9913 31.437 42.8337 31.5946C42.6762 31.7522 42.4624 31.8407 42.2396 31.8407H25.434C25.2112 31.8407 24.9974 31.7522 24.8399 31.5946C24.6823 31.437 24.5938 31.2233 24.5938 31.0004C24.5938 30.7776 24.6823 30.5639 24.8399 30.4063C24.9974 30.2487 25.2112 30.1602 25.434 30.1602Z",
    fill: "#1E53E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7838 31.0005L32.7531 37.9681C32.9109 38.1259 32.9995 38.3399 32.9995 38.563C32.9995 38.7862 32.9109 39.0002 32.7531 39.1579C32.5953 39.3157 32.3813 39.4044 32.1582 39.4044C31.935 39.4044 31.7211 39.3157 31.5633 39.1579L24.0008 31.5954C23.9225 31.5174 23.8604 31.4247 23.8181 31.3226C23.7757 31.2205 23.7539 31.111 23.7539 31.0005C23.7539 30.89 23.7757 30.7806 23.8181 30.6785C23.8604 30.5764 23.9225 30.4837 24.0008 30.4056L31.5633 22.8431C31.7211 22.6853 31.935 22.5967 32.1582 22.5967C32.3813 22.5967 32.5953 22.6853 32.7531 22.8431C32.9109 23.0009 32.9995 23.2149 32.9995 23.438C32.9995 23.6612 32.9109 23.8752 32.7531 24.0329L25.7838 31.0005Z",
    fill: "#1E53E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4468_4380",
    x: 0.8,
    y: 0.8,
    width: 64.4,
    height: 64.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.282353 0 0 0 0 0.54902 0 0 0 0 0.792157 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4468_4380"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4468_4380",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecidingscreengoout);
export default __webpack_public_path__ + "static/media/decidingscreengoout.402e2ea3aea93f15efa3778454a2ac93.svg";
export { ForwardRef as ReactComponent };